// import 'animate.css';
// import Swiper, {Navigation} from 'swiper';
// import 'swiper/css';
// import 'swiper/css/navigation';
import './scss/block_1.scss';

window.addEventListener("load", function () {
    $('.currentInput').change(function () {
        if ($(this).is(':checked')) {
            $('#float_right').css('top', 46 + '%')
        } else {
            $('#float_right').css('top', 30 + '%')

        }
    });
});